import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { forkJoin } from 'rxjs';
import { SupplierService } from '../supplier.service';
import { SupplierProfile } from '../supplier.type';
import { PaymentService } from '../../payment/payment.service';
import { PaymentDestination } from '../../payment/payment.type';

@Component({
  selector: 'app-supplier-info-dialog',
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './supplier-info-dialog.html',
  styleUrl: './supplier-info-dialog.scss',
})
export class SupplierInfoDialog implements OnInit {
  readonly dialogRef = inject(MatDialogRef<SupplierInfoDialog>);
  readonly data = inject<{ supplierId: string; supplierUsername?: string }>(MAT_DIALOG_DATA);
  private supplierService = inject(SupplierService);
  private paymentService = inject(PaymentService);
  private snackBar = inject(MatSnackBar);

  loading = true;
  notFound = false;
  profile: SupplierProfile | null = null;
  destinations: PaymentDestination[] = [];

  ngOnInit(): void {
    forkJoin({
      profile: this.supplierService.getSupplier(this.data.supplierId),
      destinations: this.paymentService.getPaymentDestinations(this.data.supplierId),
    }).subscribe({
      next: ({ profile, destinations }) => {
        this.profile = profile;
        this.destinations = destinations;
        this.loading = false;
      },
      error: err => {
        this.notFound = err?.status === 404;
        if (!this.notFound) {
          this.snackBar.open('Error loading supplier info', 'Close', { duration: 5000 });
        }
        this.loading = false;
      },
    });
  }

  close() {
    this.dialogRef.close();
  }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text).then(() => {
      this.snackBar.open('Copied!', undefined, { duration: 1500 });
    });
  }
}
